import { useSearchParams } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { MembersTab } from './tabs/members';
import { OrganizationTab } from './tabs/organization';
import { ProfileTab } from './tabs/profile';
import { SecurityTab } from './tabs/security';

const TABS = [
  { value: 'profile', label: 'Profile', Component: ProfileTab },
  { value: 'security', label: 'Security', Component: SecurityTab },
  { value: 'organization', label: 'Organization', Component: OrganizationTab },
  { value: 'members', label: 'Members', Component: MembersTab },
] as const;

const DEFAULT_TAB = TABS[0].value;

export const SettingsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  /**
   * The active tab lives in the query string so a tab is linkable and survives a
   * reload. An unrecognised value falls back rather than rendering nothing.
   */
  const requested = searchParams.get('tab');
  const activeTab = TABS.some((tab) => tab.value === requested)
    ? requested!
    : DEFAULT_TAB;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl font-semibold tracking-tight text-ink">
          Account
        </h1>
        <p className="mt-1 text-sm text-ink-muted">
          Your profile, security, and organization access.
        </p>
      </div>

      <Tabs
        value={activeTab}
        onValueChange={(value) =>
          // `replace` keeps tab switching out of the browser's back history.
          setSearchParams({ tab: value }, { replace: true })
        }
      >
        <TabsList>
          {TABS.map((tab) => (
            <TabsTrigger key={tab.value} value={tab.value}>
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>

        {TABS.map(({ value, Component }) => (
          <TabsContent key={value} value={value} className="max-w-2xl">
            <Component />
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
};
